import React from 'react';
import './_headerbar.css';
import BlueButton from '../Button';

const WarningNotification = props => {
    
    return(
        <div id="header-notifications-info">
            <div>
                {
                    props.notificationsStatus === "denied" ?
                        <span className="max-width">As notificações estão bloqueadas nas configurações do navegador</span>
                    : 
                        <span className="max-width">
                            <h4>As notificações do navegador estão desativadas.</h4>
                            <BlueButton 
                                onClick={()=>props.showPrompt()}                    
                                >
                                Ativar notificações
                            </BlueButton> 
                        </span>
                }                
                <span className="close-warning" onClick={()=>props.hideWarning()}>X Fechar</span>
            </div>            
        </div>
    )
}

export default WarningNotification;


// WEBPACK FOOTER //
// ./src/components/headerbar/WarningNotification.js